import { t } from "@/i18n-js/instance";
import { SECTION_LABELS } from "@circle-react/components/Spaces/CourseSpace/AdminSummary/EditLabelsModal";
import { LESSON_LABELS } from "@circle-react/components/Spaces/CourseSpace/AdminSummary/EditLabelsModal";
import { Form } from "@circle-react-shared/uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";

export const CustomizeLabels = () => {
  const lessonOptions = LESSON_LABELS.map(label => ({
    label: t(`courses.labels.${label}.singular`),
    value: label,
  })).sort((a, b) => a.label.localeCompare(b.label));

  const sectionOptions = SECTION_LABELS.map(label => ({
    label: t(`courses.labels.${label}.singular`),
    value: label,
  })).sort((a, b) => a.label.localeCompare(b.label));

  return (
    <>
      <Typography.TitleMd color="text-darkest">
        {t("courses.directory.options_modal.customize_labels.title")}
      </Typography.TitleMd>
      <Typography.BodyMd color="text-default">
        {t("courses.directory.options_modal.customize_labels.description")}
      </Typography.BodyMd>
      <Form.Item
        hideDescription
        hideBorder
        label={t("spaces.form.create.edit_labels.section")}
        name="custom_section_label"
      >
        <Form.SelectNative
          name="custom_section_label"
          options={sectionOptions}
          placeholder={t("courses.labels.section.singular")}
        />
      </Form.Item>
      <Form.Item
        hideDescription
        hideBorder
        label={t("spaces.form.create.edit_labels.lesson")}
        name="custom_lesson_label"
        className="mb-8"
      >
        <Form.SelectNative
          name="custom_lesson_label"
          options={lessonOptions}
          placeholder={t("courses.labels.lesson.singular")}
        />
      </Form.Item>
    </>
  );
};
